// Legacy notifications service — used by components/notifications-legacy/NotificationsPage.js
import axios from '@fs/zion-axios'

export const subscribeToEmail = ({ value, page, reason }) =>
  axios.post(
    `/service/messaging/preferences/preferences/optin?value=${value}&page=${page}&reason=${reason}&channel=email`
  )

export const subscribeToTextMessages = (subscribed = true) =>
  axios.post('/service/messaging/preferences/preferences/categories', {
    SMS: { MailboxMessage: { lastModified: formatISO(new Date()), subscribed } },
  })

export const subscribeToTextMessageCampaign = ({ value, page, reason }) =>
  axios.post(
    `/service/messaging/preferences/preferences/optin?value=${value}&page=${page}&reason=${reason}&channel=sms`
  )

export const subscribeToWhatsAppCampaign = ({ value, page, reason }) =>
  axios.post(
    `/service/messaging/preferences/preferences/optin?value=${value}&page=${page}&reason=${reason}&channel=whatsapp`
  )

export const unsubscribeToTextMessages = () => subscribeToTextMessages(false)

// Check user's family groups list, if it's empty, do not display email toggle
export const getFamilyGroupsList = () =>
  axios.get('/service/tree/tree-data/groups/current-groups').then((res) => res.data?.memberSummaries ?? [])

function formatISO(date) {
  const iso = date.toISOString()
  return `${iso.substring(0, iso.indexOf('.'))}Z`
}
